// -- super function to close dropdown from all js files --
const closeDropdown = function() {
  const ddListAll = document.querySelectorAll('.dropdown__list');
  ddListAll.forEach(function(ddList) {
    ddList.previousElementSibling.setAttribute('aria-expanded', false);
    ddList.previousElementSibling.querySelector('.icon--dropdown svg').classList.remove('rotate-180');
    ddList.classList.add('hidden');
  });  
};

ready(function(){
	
	// -- variables --
	const body = document.body;
  const ddTogglesAll = document.querySelectorAll('.dropdown__toggle');
	const learnMoreMenuBtn = document.getElementById('learnMoreMenuBtn');
  
  // -- toggle dropdown state --
  ddTogglesAll.forEach(function(ddToggle) {
    ddToggle.addEventListener('click', function(e) {
      let ddList = ddToggle.nextElementSibling;
      let ddIconSvg = ddToggle.querySelector('.icon--dropdown svg');
      let shouldOpen = ddList.classList.contains('hidden');
      e.preventDefault();
      closeDropdown();
  		body.classList.remove('learnMoreMenuOpen');
			learnMoreMenuBtn.classList.remove('is-active');
      if (shouldOpen) {
	      ddToggle.setAttribute('aria-expanded', true);
    	  ddIconSvg.classList.add('rotate-180');
    	  ddList.classList.remove('hidden');
      }
      e.stopPropagation();
    });
  });

  // -- close dropdown__list when clicking outside --
  window.addEventListener('click', function(event) {
    if (event.target != ddTogglesAll) {
      closeDropdown();
    }
  });

});